import Stepper from "components/Stepper";
import FormContasBancarias from "./components/FormContasBancarias/index";
import { Box } from "@chakra-ui/react";
import FormRecebimentoVendas from "./components/FormRecebimentoVendas/index";
import { Control, UseFormSetValue } from "react-hook-form";
import FormPagamentosCompras from "./components/FormPagamentosCompras/index";
import FormHistorico from "./components/FormHistorico/index";
import FormResumo from "./components/FormResumo/index";
import FormDownload from "./components/FormDownload/index";
import { FiltroExportacaoContabil } from "features/exportacao-contabil/typings";
import {
  ExportacaoContabilDto,
  ExportacaoContabilForm,
} from "features/exportacao-contabil/typings/index";
interface FormExportacaoContabilProps {
  setCurrentStep: any;
  currentStep: number;
  control: Control<ExportacaoContabilForm, any>;
  setValue: UseFormSetValue<ExportacaoContabilForm>;
  form: ExportacaoContabilForm;
  data?: ExportacaoContabilDto;
  filtro: FiltroExportacaoContabil;
  handleSave: () => any;
  loading?: boolean;
}

export default function FormExportacaoContabil({
  currentStep,
  setCurrentStep,
  control,
  form,
  data,
  filtro,
  setValue,
  handleSave,
  loading,
}: FormExportacaoContabilProps) {
  const _steps = [
    { title: "Contas bancárias" },
    { title: "Recebimento e vendas" },
    { title: "Pagamentos e compras" },
    { title: "Histórico" },
    { title: "Resumo" },
    { title: "Download" },
  ];

  return (
    <>
      <Stepper
        steps={_steps}
        current={currentStep}
        onClickStep={setCurrentStep}
      />

      <Box py={4}>
        <Step isCurrentStep={currentStep === 0}>
          <FormContasBancarias
            form={form}
            control={control}
            setValue={setValue}
            loading={loading}
          />
        </Step>

        <Step isCurrentStep={currentStep === 1}>
          <FormRecebimentoVendas
            receitas={data?.receitas}
            form={form}
            control={control}
            filtro={filtro}
          />
        </Step>

        <Step isCurrentStep={currentStep === 2}>
          <FormPagamentosCompras
            despesas={data?.despesas}
            form={form}
            control={control}
            filtro={filtro}
          />
        </Step>

        <Step isCurrentStep={currentStep === 3}>
          <FormHistorico data={data} control={control} form={form} />
        </Step>

        <Step isCurrentStep={currentStep === 4}>
          <FormResumo control={control} />
        </Step>

        <Step isCurrentStep={currentStep === 5}>
          <FormDownload handleSave={handleSave} />
        </Step>
      </Box>
    </>
  );
}

const Step = ({
  isCurrentStep,
  children,
}: {
  isCurrentStep: boolean;
  children: React.ReactNode;
}) => {
  return <Box display={isCurrentStep ? "block" : "none"}>{children}</Box>;
};
